// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"HN-z","carouselContainer":"IN-z"};